import { InvoiceList } from "./List/List"
import { InvoiceCreate } from "./Create"

export const adminInvoicesResource = {
	list: InvoiceList,
	create: InvoiceCreate,
}